export const hasNonEmptyValues = (item) => {
  if (Array.isArray(item)) {
    return item.some(hasNonEmptyValues);
  }

  if (item && typeof item === 'object') {
    return Object.entries(item)
      .filter(([key]) => key !== 'id')
      .some(([, value]) => hasNonEmptyValues(value));
  }

  return (
    item !== null &&
    item !== undefined &&
    item !== "" &&
    !(typeof item === "object" && Object.keys(item).length === 0)
  );
};

export const transformListItem = (item, fieldName) => ({
  ...item,
  [fieldName]: item[fieldName]?.label || item[fieldName],
});

export const toSelectOption = (value) => {
  if (!value) return undefined;
  return {
    label: value.label || value,
    value: value.value || value,
  };
};

export const initialData = (data) => {
  if (!data) return [];

  return data.map((item) => ({
    ...item,
    fullName: toSelectOption(item?.fullName),
    dealNumber: toSelectOption(item?.dealNumber),
  }));
};

export const transformServiceData = (data) => {
  const transformField = (fieldName, keyField) =>
    data?.[fieldName]
      ?.filter(hasNonEmptyValues)
      ?.map((item) => transformListItem(item, keyField));

  const transformSuspiciousTransactions = () =>
    data?.suspiciousTransactions?.map((transaction) => {
      const operations = transaction.financeSuspiciousOperations.map((subItem) =>
        transformListItem(subItem, "dealNumber")
      );

      const filteredOperations = operations.filter(({ id, ...rest }) => hasNonEmptyValues(rest));

      return {
        ...transaction,
        financeSuspiciousOperations: filteredOperations.length > 0 ? filteredOperations : [],
      };
    }) || [];

  return {
    ...data,
    furtherActions: transformField("furtherActions", "fullName"),
    blockTransactions: transformField("blockTransactions", "fullName"),
    suspiciousTransactions: transformSuspiciousTransactions(),
  };
};
